import { render, staticRenderFns } from "./select-option.vue?vue&type=template&id=1ab11b0c"
import script from "./select-option.vue?vue&type=script&lang=js"
export * from "./select-option.vue?vue&type=script&lang=js"
import style0 from "./select-option.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports